import React from 'react';

import { storiesOf } from '@storybook/react';

import { OtherCourtInfo } from './OtherCourtInfo';

storiesOf('Case Menu/Other Court Information', module)

  .add('Showing', () => <div>
    <OtherCourtInfo
        otherCourtInfo={otherCourtInfoData.data}
      />
  </div>
  )

  .add('Empty', () => (
    <div>
      <h3> Other Court Information Empty</h3>
      <hr />
      <OtherCourtInfo
        otherCourtInfo={otherCourtInfoEmpty.data}
      />
    </div>
  ));

const otherCourtInfoData = {
  data: {
    html: '<B>Other Court Information</B><P><TABLE border=1><TR><TH>Court Name</TH><TH>Case Number</TH><TH>Start Date</TH><TH>End Date</TH></TR><TR><TD>Johnson County District Court</TD><TD>16CV01866</TD><TD>04/21/2016</TD><TD></TD></TR></TABLE>',
  },
};

const otherCourtInfoEmpty = {
  data: {
    empty: 'There are no related info.',
  },
};



// WEBPACK FOOTER //
// ./src/components/case/associated_cases/OtherCourtInfo.stories.jsx